// components/SearchTabs.jsx
import React from "react"
import { useTranslation } from "react-i18next"
import { cn } from "../../../lib"

const TABS = [
  { key: "tour", labelKey: "filter.tours", href: "/book/filter/packages" },
  { key: "bus", labelKey: "dashboard.bus_tickets", href: "/book/filter/bus" },
  { key: "avia", labelKey: "dashboard.avia_tickets", href: "/book/filter/transport" },
  { key: "excursion", labelKey: "modules.travel_excursion", href: "/book/filter_excursion/index" },
  { key: "insurance", labelKey: "admin.insurance", href: "/book/filter_insurance/index" },
  { key: "service", labelKey: "admin.service_search", href: "/book/service/search" },
]

const SearchTabs = ({ active }) => {
  const { t } = useTranslation()

  return (
    <div className="flex gap-6 overflow-x-auto border-b border-gray-200 mt-4 mb-6 px-1 overflow-y-clip">
      {TABS.map((tab) => {
        const isActive = tab.key === active

        return (
          <a
            key={tab.key}
            href={tab.href}
            aria-current={isActive ? "page" : undefined}
            className={cn(
              "relative whitespace-nowrap pb-3 pt-1 text-sm font-medium transition-colors shrink-0",
              isActive ? "text-orange-600" : "text-gray-500 hover:text-gray-800"
            )}
          >
            {t(tab.labelKey)}
            {isActive && (
              <span className="absolute left-0 right-0 -bottom-px h-[2px] rounded-full bg-orange-500" />
            )}
          </a>
        )
      })}
    </div>
  )
}

export default SearchTabs
